import { apiClient, REVIEW_REQUESTS } from '../../../../shared/api';
import { DEFAULT_PER_PAGE } from '../../../../shared/constants';

export const createReviewRequest = async (reviewRequestData) => {
  const { channel, taskId } = reviewRequestData;

  const requestBody = {
    review_request: {
      channel: channel,
      task_id: taskId,
    },
  };

  const response = await apiClient.post(REVIEW_REQUESTS, requestBody);

  return response.data;
};

export const fetchReviewRequests = async ({ page = 1, perPage = DEFAULT_PER_PAGE }) => {
  const params = {
    include: 'client_task.client,client_task.task',
    page: {
      number: page,
      size: perPage,
    },
  };

  const response = await apiClient.get(REVIEW_REQUESTS, {
    includeWebsite: true,
    params,
  });

  return response.data;
};
